import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext, useState } from 'react';
var UserContext = /*#__PURE__*/React.createContext({
  user: {},
  setUser: function setUser(user) {}
});
export var UserProvider = function UserProvider(_ref) {
  var initialUser = _ref.user,
    children = _ref.children;
  var _useState = useState(initialUser || {}),
    _useState2 = _slicedToArray(_useState, 2),
    user = _useState2[0],
    setUser = _useState2[1];
  return /*#__PURE__*/React.createElement(UserContext.Provider, {
    value: {
      user: user,
      setUser: setUser
    }
  }, children);
};
export function useUserContext() {
  return useContext(UserContext);
}